export type SetType = {
  code: string
  icon_svg_uri?: string
  name: string
}

export type TagType = {
  count: number
  name: string
  slug: string
}

export type TribeType = string

export type MiscStateType = {
  articles: {
    name: string
    slug: string
  }[]
  guides: {
    name: string
    slug: string
  }[]
  precons: {
    name: string
    precons: {
      name: string
      slug: string
    }[]
    tag: string
  }[]
  sets: SetType[]
  tags: TagType[]
  tcgplayerKickback?: {
    end: Date
    percent: number
    start: Date
  }
  tcgplayerSale: number
}

export const initialMiscState: MiscStateType = {
  articles: [],
  guides: [],
  precons: [],
  sets: [],
  tags: [],
  tcgplayerSale: 0,
}
